import { FuseScrollbars } from '@fuse';
import _ from '@lodash';
import { AppBar, DialogContent, Icon, IconButton, Paper, TextField, Toolbar, Typography, withStyles } from '@material-ui/core';
import { fade } from '@material-ui/core/styles/colorManipulator';
import CatchErro from 'app/Core/Components/CatchErro/CatchErro';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import { GetDataHoraAtual, StringDateUSToBR } from 'app/Core/Helpers';
import * as AppActions from 'app/store/actions';
import withReducer from 'app/store/withReducer';
import clsx from 'clsx';
import MobileDetect from 'mobile-detect';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import XAPPButton from '../Button/XAPPButton';
import XAPPDialog from '../Dialog/XAPPDialog';
import * as Actions from './Store/Actions/MensagemActions';
import reducer from './Store/Reducers/MensagemReducer';

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    root: {
        background: `linear-gradient(to bottom, ${fade(theme.palette.background.paper, 0.8)} 0,${fade(theme.palette.background.paper, 0.6)} 20%,${fade(theme.palette.background.paper, 0.8)})`,
        height: '90%',
        maxHeight: '90%',
    },
    content: {
        height: '80%',
        maxHeight: '80%',
    },
    bgPaper: {
        background: theme.palette.background.paper
    },
    messageRow: {
        '&.contact': {
            '& .bubble': {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                borderTopLeftRadius: 5,
                borderBottomLeftRadius: 5,
                borderTopRightRadius: 20,
                borderBottomRightRadius: 20,
                '& .time': {
                    marginLeft: 12
                }
            },
            '&.first-of-group': {
                '& .bubble': {
                    borderTopLeftRadius: 20
                }
            },
            '&.last-of-group': {
                '& .bubble': {
                    borderBottomLeftRadius: 20
                }
            }
        },
        '&.me': {
            paddingLeft: 40,
            '& .bubble': {
                marginLeft: 'auto',
                // backgroundColor: theme.palette.grey[300],
                backgroundColor: theme.palette.primary.dark,
                //color: theme.palette.getContrastText(theme.palette.grey[300]),
                color: theme.palette.primary.contrastText,
                borderTopLeftRadius: 20,
                borderBottomLeftRadius: 20,
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                '& .time': {
                    display: "flex",
                    justifyContent: "end",
                    marginRight: 12
                }
            },
            '&.first-of-group': {
                '& .bubble': {
                    borderTopRightRadius: 20
                }
            },

            '&.last-of-group': {
                '& .bubble': {
                    borderBottomRightRadius: 20
                }
            }
        },
        '&.contact + .me, &.me + .contact': {
            paddingTop: 20,
            marginTop: 20
        },
        '&.first-of-group': {
            '& .bubble': {
                borderTopLeftRadius: 20,
                paddingTop: 13
            }
        },
        '&.last-of-group': {
            '& .bubble': {
                borderBottomLeftRadius: 20,
                paddingBottom: 13,
                '& .time': {
                    display: 'flex'
                }
            }
        }
    }
});

class Mensagem extends XAPPComponent {

    state = {
        open: false,
        tipo: 1,
        mensagem: "",
    }

    componentDidMount() {
        const { xappRouteParams, SETUP, children = null } = this.props;
        if (_.isNull(children)) {
            this.props.list(SETUP, xappRouteParams);
        }
    }

    componentWillUnmount() {
        this.props.clearReducer();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.Reducer.error) {
            this.props.showMessage({
                message: this.props.Reducer.error,
                variant: 'error'
            });
            this.props.Reducer.error = null;
        }
        if (this.props.Reducer.info) {
            this.props.Reducer.info = null;
        }

        const form = this.state;
        const { addParticipante, SETUP, xappRouteParams, children, callback = null } = this.props;
        if (form.open && !prevState.open) {
            if (!_.isNull(children)) {
                this.props.list(SETUP, xappRouteParams);
            }
        }


        if (!form.open && prevState.open) {
            addParticipante({ ...SETUP }, xappRouteParams);
            if (!_.isNull(callback)) {
                callback();
            }
        }
    }

    handleMensagem = (ev) => {
        this.setState(_.set({ ...this.state }, 'mensagem', ev.target.value));
    }

    canBeSend = () => {
        const form = this.state;
        return (form.mensagem.length > 0);
    }

    enviar = () => {
        const { save, xappRouteParams, SETUP, Reducer, user } = this.props;
        const ASetup = JSON.parse(JSON.stringify(SETUP));
        ASetup.conteudo = {
            [SETUP.campo]: {
                participantes: {},
                mensagens: []
            }
        };
        if (!_.isNull(Reducer.participantes)) {
            ASetup.conteudo[SETUP.campo].participantes = Reducer.participantes;
        }
        if (!_.isNull(Reducer.mensagens)) {
            ASetup.conteudo[SETUP.campo].mensagens = Reducer.mensagens;
        }
        ASetup.conteudo[SETUP.campo].mensagens.push({
            remetente: user.usuario,
            remetentenome: user.nome,
            mensagem: this.state.mensagem,
            datahora: GetDataHoraAtual("usa")

        });
        save(ASetup, xappRouteParams);
        this.setState(_.set({ ...this.state }, 'mensagem', ""));
    }

    openDialog = ev => {
        ev.stopPropagation();
        this.setState(_.set({ ...this.state }, "open", !this.state.open));
    }

    getCount = () => {
        const form = this.state;
        const { Reducer, user } = this.props;
        let ACount = 0;
        let AData = '1990-01-01';
        if (!_.isNull(Reducer.participantes) && Reducer.participantes[user.usuario]) {
            AData = Reducer.participantes[user.usuario];
        }
        if (!_.isUndefined(AData) && !_.isNull(AData) && !_.isNull(Reducer.mensagens)) {
            Reducer.mensagens.forEach(item => {
                if (!_.isEqual(item.remetente, user.usuario) && new Date(item.datahora) > new Date(AData)) {
                    ACount++;
                }
            });
        }
        return ACount;
    }

    render() {
        const { classes, children = null, Reducer, user, className, SETUP, xappRouteParams, header = null } = this.props;
        const form = this.state;

        return (
            <React.Fragment>
                <CatchErro
                    url={this.props.match.url}
                >
                    {!_.isNull(children) ?
                        <div className="cursor-pointer" onClick={this.openDialog} >
                            {children}
                        </div>
                        :
                        <XAPPButton
                            tooltip={{ "title": "Chat", "placement": "top" }}
                            type="Icon"
                            className={className}
                            iconProps={clsx(!_.isNull(Reducer.mensagens) && Reducer.mensagens.length > 0 && "text-red")}
                            onClick={this.openDialog}
                            icon={"chat"}
                            badge={this.getCount()}
                        />
                    }
                    <XAPPDialog
                        id="Mensagem"
                        open={form.open}
                        onClose={this.openDialog}
                        fullWidth
                        fullScreen={md.mobile() !== null}
                        maxWidth="sm"
                    >
                        <AppBar position="static" elevation={1}>
                            <Toolbar className="flex w-full min-h-0">
                                <Typography variant="subtitle1 text-white">
                                    {!_.isNull(header) ? (header.substring(0, 44) + ".") : "Mensagens"}
                                </Typography>
                                <div style={{ flex: 1 }} />
                                <XAPPButton
                                    type="Icon"
                                    className="text-white"
                                    onClick={this.openDialog}
                                    icon={"close"}
                                />
                            </Toolbar>
                        </AppBar>
                        <DialogContent id="contentScroll" className="min-h-400 p-0">
                            <div className={clsx(classes.content, "p-8 flex flex-col h-inherit relative")}>
                                <FuseScrollbars
                                    containerRef={(ref) => {
                                        this.chatScroll = ref
                                    }}
                                    className="flex flex-1 flex-col overflow-y-auto h-inherit mb-64"
                                >
                                    {!_.isNull(Reducer.mensagens) && Reducer.mensagens.length > 0 && Reducer.mensagens.map((item, x) => {
                                        if (x === Reducer.mensagens.length - 1 && form.open && !_.isNull(document.getElementById("contentScroll"))) {
                                            document.getElementById("contentScroll").scrollTop = document.getElementById("contentScroll").offsetHeight * 3;
                                        }
                                        return (
                                            <div
                                                key={item.idmensagem}
                                                className={clsx(
                                                    classes.messageRow,
                                                    "flex flex-col flex-no-grow flex-no-shrink items-start justify-end relative pr-16 pb-4 pl-16",
                                                    { 'me': item.remetente === user.usuario },
                                                    { 'contact': item.remetente !== user.usuario },
                                                    //{'first-of-group': this.isFirstMessageOfGroup(item, i)},
                                                    //{'last-of-group': this.isLastMessageOfGroup(item, i)}
                                                )}
                                            >
                                                <div className="bubble flex flex-col min-h-48 relative max-w-full">
                                                    {item.remetente !== user.usuario &&
                                                        <Typography
                                                            className="w-full text-10 pl-8 pr-12 whitespace-no-wrap text-white"
                                                            color="textSecondary"
                                                        >
                                                            {item.remetentenome}
                                                        </Typography>
                                                    }
                                                    <div className={clsx("leading-tight whitespace-pre-wrap mx-12 my-4")}>{item.mensagem}</div>
                                                    <Typography
                                                        className="time w-full text-10 px-12 mb-4 whitespace-no-wrap text-white"
                                                        color="textSecondary"
                                                    >
                                                        {StringDateUSToBR(item.datahora)}
                                                    </Typography>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </FuseScrollbars>
                            </div>
                            <div className={clsx(classes.bgPaper, "absolute pin-b pin-r pin-l py-12 px-8")}>
                                <Paper className="flex items-center relative rounded-24" elevation={1}>
                                    <XAPPButton
                                        type="Icon"
                                        className=""
                                        onClick={() => this.props.list(SETUP, xappRouteParams)}
                                        icon={"refresh"}
                                    />
                                    <TextField
                                        autoFocus={true}
                                        id="message-input"
                                        className="flex-1"
                                        InputProps={{
                                            disableUnderline: true,
                                            classes: {
                                                root: "flex flex-grow flex-no-shrink ml-16 mr-48 my-8",
                                                input: ""
                                            },
                                            placeholder: "Mensagem"
                                        }}
                                        InputLabelProps={{
                                            shrink: false,
                                            className: classes.bootstrapFormLabel
                                        }}
                                        onChange={this.handleMensagem}
                                        value={form.mensagem}
                                        onKeyPress={(ev) => {
                                            if (ev.charCode === 13) {
                                                this.enviar()
                                            }
                                        }}
                                    />
                                    <IconButton
                                        className="absolute pin-r pin-t"
                                        onClick={() => this.enviar()}>
                                        <Icon className="text-24" color="action">send</Icon>
                                    </IconButton>
                                </Paper>
                            </div>
                        </DialogContent>
                    </XAPPDialog>
                </CatchErro>
            </React.Fragment>
        )
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        list: Actions.list,
        addParticipante: Actions.addParticipante,
        clearReducer: Actions.clearReducer,
        save: Actions.save,
        showMessage: AppActions.showMessage
    }, dispatch);
}

function mapStateToProps({ Mensagem, fuse, auth }) {
    return {
        Reducer: Mensagem,
        theme: fuse.settings.mainTheme,
        user: auth.user.data
    }
}

export default withReducer('Mensagem', reducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Mensagem))));
